import TransactionsTable from "./TransactionsTable";

export default function Cart() {
    return (
        <div className="xbox__div-2 tx__information">
            <TransactionsTable />
        </div>
    );
}